module.exports = __webpack_public_path__ + "static/media/trash.505482f5.svg";